module.exports = __webpack_public_path__ + "img/5b7ab1c.svg";